import Vue from "vue";
import VueRouter from "vue-router";

import i18n from '@/languages' // internationalization

Vue.use(VueRouter);

// 懒加载布局组件，减少首屏加载时间
 //const Layout = () => import("@/layout/index.vue");///* webpackChunkName: "layout" */ 
import Layout from "@/layout";
// 登录页使用懒加载
const LoginView = () => import(/* webpackChunkName: "login" */ "@/views/login/index.vue");



export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import(/* webpackChunkName: "redirect" */ "@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        // 首页使用独立chunk，优先加载
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index2025"),
        // component: () => import(/* webpackChunkName: "dashboard" */ "@/views/demo/map"),
        // component: () => import(/* webpackChunkName: "dashboard" */ "@/views/driver/BoCAdaptive/BoCAdaptive_Area"),
        // component: () => import(/* webpackChunkName: "dashboard" */ "@/views/maintenance/maintenanceReminder/index"),
        //  component: () => import(/* webpackChunkName: "dashboard" */ "@/views/statistics/energyConspt/summy"),
        
        meta: { title: "dashboard", icon: "dashboard", affix: true },
      },
    ],
  },
  {
    path: "/inspectiondetail",
    name: "inspectiondetail",
    component: () => import(/* webpackChunkName: "driver" */ "@/views/driver/vehicleInspection/inspectiondetail"),
  },
  // 限速管理模块 - 统一打包到 speedlimit chunk
  {
    path: "/speedlimit",
    component: Layout,
    children: [
      {
        path: "hightlimit",
        component: () => import(/* webpackChunkName: "speedlimit" */ "@/views/vmonitor/speedlimit/hightlimit"),
        name: "hightlimit",
        meta: { title: i18n.t('speedlimit.HspeedContr'), icon: "hightlimit" },
      },
      {
        path: "arealimit",
        component: () => import(/* webpackChunkName: "speedlimit" */ "@/views/vmonitor/speedlimit/arealimit"),
        name: "arealimit",
        meta: { title:i18n.t('speedlimit.DspeedContr') , icon: "arealimit" },
      },
      {
        path: "time_speed_set",
        component: () => import(/* webpackChunkName: "speedlimit" */ "@/views/vmonitor/speedlimit/time_speed_set"),
        name: "time_speed_set",
        meta: { title:i18n.t('speedlimit.NspeedContr') , icon: "time_speed_set" },
      },
      {
        path: "tired_limit_speed_set",
        component: () => import(/* webpackChunkName: "speedlimit" */ "@/views/vmonitor/speedlimit/tired_limit_speed_set"),
        name: "tired_limit_speed_set",
        meta: { title: i18n.t('speedlimit.TiredDspeedContr'), icon: "tired_limit_speed_set" },
      },
      {
        path: "hightremind",
        component: () => import(/* webpackChunkName: "speedlimit" */ "@/views/vmonitor/speedlimit/hightremind"),
        name: "hightremind",
        meta: { title: i18n.t('speedlimit.HspeedWarn'), icon: "hightremind" },
      },
      {
        path: "arealimitremind",
        component: () => import(/* webpackChunkName: "speedlimit" */ "@/views/vmonitor/speedlimit/arealimitremind"),
        name: "arealimitremind",
        meta: { title: i18n.t('speedlimit.DspeedWarn'), icon: "arealimitremind" },
      },
      {
        path: "PartRoadSpeedlimit",
        component: () => import(/* webpackChunkName: "speedlimit" */ "@/views/vmonitor/speedlimit/PartRoadSpeedlimit"),
        name: "PartRoadSpeedlimit",
        meta: { title: i18n.t('speedlimit.SubspeedWarn'), icon: "PartRoadSpeedlimit" },
      },
    ],
  },

  // {
  //   path: "/maintenance",
  //   component: () => import("@/layout/index.vue"),

  //   children: [
  //     {
  //       path: "yearlyOrQuarter",
  //       component: () => import("@/views/maintenance/yearlyOrQuarter"),
  //       name: "运营证年检/季检",
  //       meta: { title: "运营证年检/季检", icon: "yearlyOrQuarter" },
  //     },
  //     {
  //       path: "annualInspection",
  //       component: () => import("@/layout/index.vue"),

  //       component: () => import("@/views/maintenance/annualInspection/index"),
  //       name: "年检登记",
  //       meta: { title: "年检登记", icon: "yearlyOrQuarter" },
  //     },
  //     {
  //       path: "insurance",
  //       component: () => import("@/layout/index.vue"),

  //       component: () => import("@/views/maintenance/insurance/index"),
  //       name: "保险登记",
  //       meta: { title: "保险登记", icon: "yearlyOrQuarter" },
  //     },
  //     {
  //       path: "upkeep",
  //       component: () => import("@/layout/index.vue"),

  //       component: () => import("@/views/maintenance/upkeep/index"),
  //       name: "保养登记",
  //       meta: { title: "保养登记", icon: "yearlyOrQuarter" },
  //     },
  //   ],
  // },

  // 节油驾驶模块
  {
    path: "/fuel_efficient_driving",
    component: Layout,
    children: [
      {
        path: "abnormal_detail",
        component: () => import(/* webpackChunkName: "driver" */ "@/views/driver/fuel_efficient_driving/abnormal_detail/index"),
        name: "abnormal_detail",
        meta: { title: i18n.t('fuelEfficientDriving.异常驾驶行为'), icon: "abnormal_detail" },
      },
    ],
  },

  // 系统设置模块
  {
    path: "/setting",
    component: Layout,
    children: [
      {
        path: "changepsw",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/changepsw/index"),
        name: "changePsw",
        meta: { title: "changepsw", icon: "changepsw" },
      },
      {
        path: "feedback",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/feedback/index"),
        name: "feedback",
        meta: { title: "feedback", icon: "feedback" },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },

];

// const router = new VueRouter({
//   scrollBehavior: () => ({ y: 0 }),
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes:constantRoutes
// })

const createRouter = () =>
  new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
